import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import useApp from 'hooks/useApp'
import { Button, LayerBottom, Logo } from 'components'
import shSymbol from 'images/tmp_shinhyup_symbol.png'
import shinHanSymbol from 'images/tmp_shinhan_symbol.png'
import styles from './index.module.css'
import Lib from 'library'

const Report = () => {

	const App = useApp()
	const [showLayer, setShowLayer] = useState(false)
	const [today, setToday] = useState()  // 오늘 날자
	const [accBalanceData, setAccBalanceData] = useState()  // 오늘/어제 계좌 잔액 조회
	const [balanceType, setBalanceType] = useState()  // 오늘 대비 계좌 잔액 상태
	const [acntblncData, setAcntblncData] = useState()  // 어제 계좌 잔액 목록 조회
	const [withdrExpData, setWithdrExpData] = useState()  // 지출 예정 목록조회
	const [withdrExpList, setWithdrExpList] = useState() // 지출 예정 목록 리스트
	const [listState, setListState] = useState()  // 목록 리스트

	// 더보기 버튼 설정 
	const moreSliceN = 4;  // 더보기 버튼 노출 정도
	const [accMoreBtn, setAccMoreBtn] = useState(moreSliceN)
	const [payMoreBtn, setPayMoreBtn] = useState(moreSliceN)
	const [dataAccLength, setAccDataLength] = useState(0)
	const [dataPayLength, setPayDataLength] = useState(0)
	// 더보기 버튼 설정 


	const closeConfirm = () => {
		setShowLayer(false)
	}

	const showConfirm = () => {
		setShowLayer(true)
	}

	// 초기 header 및 데이터
	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("pt_0")

		// 아래와 같이 변경
		// 인플루언서 참여 안하면 데이터가 안나와서 다시 기존 API 호출로 변경함. (2023.04.18)
		Lib.get(`/api/dlyrprt/acntblnc`, data => {
			setAccBalanceData(data);
			balanceState(data)
		})
		// 계좌 잔액에 변동사항을 내 인플루언서 포트폴리오와 동일하게 변경함. (2022.10.31)
		// Lib.post(`/api/infl/lst/dlyprtfl`, {
		// 	mbId: '',
		// 	pageNo: 0
		// }, data => {
		// 	if (data.length > 0) {
		// 		const myAmt = data[0];
		// 		const myData = {
		// 			blncAmt: myAmt.blncAmt,
		// 			prvBlncAmt: myAmt.blncAmt - myAmt.dfrnAmt
		// 		}
		// 		setAccBalanceData(myData);
		// 		balanceState(myData)
		// 	}
		// });


		Lib.get(`/api/dlyrprt/lst/withdrExp`, data => {
			
			setToday(Lib.dateFormat(data.stDe, "."));
			setWithdrExpData(data)
		})
	}, [])

	useEffect(() => {
		if (withdrExpData) {
			listExpDtlData(withdrExpData);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [withdrExpData, payMoreBtn]);

	// 내 지출 일정 정보
	const listExpDtlData = (data) => {
		let list = {}
		let payDetailList = []
		let lstWithdrExpDtl = data.lstWithdrExpDtl
		let lstWithdrExpNbr = data.lstWithdrExpNbr
		for (let i = 0; i < lstWithdrExpNbr.length; i++) {
			if (Number(lstWithdrExpNbr[i].nbr) > 0) {
				list.ddayCound = i
				list.today = lstWithdrExpNbr[i].de
				break;
			}
		}
		for (let i = 0; i < lstWithdrExpNbr.length; i++) {
			if (Array.isArray(lstWithdrExpDtl[lstWithdrExpNbr[i].de]) && lstWithdrExpDtl[lstWithdrExpNbr[i].de].length === 0) {
				// 빈배열일때 처리
			} else {
				for (let k = 0; k < lstWithdrExpDtl[lstWithdrExpNbr[i].de].length; k++) {
					payDetailList.push(lstWithdrExpDtl[lstWithdrExpNbr[i].de][k]);
				}
			}
		}
		setListState(list)
		setWithdrExpList(payDetailList.slice(0, payMoreBtn))
		setPayDataLength(Math.ceil(payDetailList.length / moreSliceN));
	}

	useEffect(() => {
		Lib.get(`/api/dlyrprt/lst/acntblnc`, data => {
			// const testacntblnc = [
			// 	{
			// 		blncAmt: "100000.000",
			// 		indstCd: "BANK1",
			// 		indstDtlCd: "자산",
			// 		indstDtlNm: "(주)우리은행",
			// 		indstNm: "은행",
			// 		insttCd: "BANK",
			// 		insttNm: "(주)우리은행",
			// 		prvBlncAmt: "90000.000"
			// 	},
			// 	{
			// 		blncAmt: "100000.000",
			// 		indstCd: "BANK2",
			// 		indstDtlCd: "자산",
			// 		indstDtlNm: "(주)우리은행",
			// 		indstNm: "은행",
			// 		insttCd: "BANK",
			// 		insttNm: "(주)우리은행",
			// 		prvBlncAmt: "46000.000"
			// 	},
			// 	{
			// 		blncAmt: "100000.000",
			// 		indstCd: "BANK3",
			// 		indstDtlCd: "자산",
			// 		indstDtlNm: "(주)우리은행",
			// 		indstNm: "은행",
			// 		insttCd: "BANK",
			// 		insttNm: "(주)우리은행",
			// 		prvBlncAmt: "120000.000"
			// 	},
			// 	{
			// 		blncAmt: "100000.000",
			// 		indstCd: "BANK4",
			// 		indstDtlCd: "자산",
			// 		indstDtlNm: "(주)우리은행",
			// 		indstNm: "은행",
			// 		insttCd: "BANK",
			// 		insttNm: "(주)우리은행",
			// 		prvBlncAmt: "100000.000"
			// 	},
			// 	{
			// 		blncAmt: "100000.000",
			// 		indstCd: "BANK5",
			// 		indstDtlCd: "자산",
			// 		indstDtlNm: "(주)우리은행",
			// 		indstNm: "은행",
			// 		insttCd: "BANK",
			// 		insttNm: "(주)우리은행",
			// 		prvBlncAmt: "90000.000"
			// 	},
			// 	{
			// 		blncAmt: "100000.000",
			// 		indstCd: "BANK6",
			// 		indstDtlCd: "자산",
			// 		indstDtlNm: "(주)우리은행",
			// 		indstNm: "은행",
			// 		insttCd: "BANK",
			// 		insttNm: "(주)우리은행",
			// 		prvBlncAmt: "46000.000"
			// 	},
			// 	{
			// 		blncAmt: "100000.000",
			// 		indstCd: "BANK7",
			// 		indstDtlCd: "자산",
			// 		indstDtlNm: "(주)우리은행",
			// 		indstNm: "은행",
			// 		insttCd: "BANK",
			// 		insttNm: "(주)우리은행",
			// 		prvBlncAmt: "120000.000"
			// 	},
			// 	{
			// 		blncAmt: "100000.000",
			// 		indstCd: "BANK8",
			// 		indstDtlCd: "자산",
			// 		indstDtlNm: "(주)우리은행",
			// 		indstNm: "은행",
			// 		insttCd: "BANK",
			// 		insttNm: "(주)우리은행",
			// 		prvBlncAmt: "100000.000"
			// 	},
			// 	{
			// 		blncAmt: "100000.000",
			// 		indstCd: "BANK9",
			// 		indstDtlCd: "자산",
			// 		indstDtlNm: "(주)우리은행",
			// 		indstNm: "은행",
			// 		insttCd: "BANK",
			// 		insttNm: "(주)우리은행",
			// 		prvBlncAmt: "46000.000"
			// 	},
			// 	{
			// 		blncAmt: "100000.000",
			// 		indstCd: "BANK10",
			// 		indstDtlCd: "자산",
			// 		indstDtlNm: "(주)우리은행",
			// 		indstNm: "은행",
			// 		insttCd: "BANK",
			// 		insttNm: "(주)우리은행",
			// 		prvBlncAmt: "120000.000"
			// 	},
			// 	{
			// 		blncAmt: "100000.000",
			// 		indstCd: "BANK11",
			// 		indstDtlCd: "자산",
			// 		indstDtlNm: "(주)우리은행",
			// 		indstNm: "은행",
			// 		insttCd: "BANK",
			// 		insttNm: "(주)우리은행",
			// 		prvBlncAmt: "100000.000"
			// 	},
			// 	{
			// 		blncAmt: "100000.000",
			// 		indstCd: "BANK12",
			// 		indstDtlCd: "자산",
			// 		indstDtlNm: "(주)우리은행",
			// 		indstNm: "은행",
			// 		insttCd: "BANK",
			// 		insttNm: "(주)우리은행",
			// 		prvBlncAmt: "90000.000"
			// 	},
			// 	{
			// 		blncAmt: "100000.000",
			// 		indstCd: "BANK13",
			// 		indstDtlCd: "자산",
			// 		indstDtlNm: "(주)우리은행",
			// 		indstNm: "은행",
			// 		insttCd: "BANK",
			// 		insttNm: "(주)우리은행",
			// 		prvBlncAmt: "46000.000"
			// 	},
			// 	{
			// 		blncAmt: "100000.000",
			// 		indstCd: "BANK14",
			// 		indstDtlCd: "자산",
			// 		indstDtlNm: "(주)우리은행",
			// 		indstNm: "은행",
			// 		insttCd: "BANK",
			// 		insttNm: "(주)우리은행",
			// 		prvBlncAmt: "120000.000"
			// 	},
			// 	{
			// 		blncAmt: "100000.000",
			// 		indstCd: "BANK15",
			// 		indstDtlCd: "자산",
			// 		indstDtlNm: "(주)우리은행",
			// 		indstNm: "은행",
			// 		insttCd: "BANK",
			// 		insttNm: "(주)우리은행",
			// 		prvBlncAmt: "100000.000"
			// 	},
			// 	{
			// 		blncAmt: "100000.000",
			// 		indstCd: "BANK16",
			// 		indstDtlCd: "자산",
			// 		indstDtlNm: "(주)우리은행",
			// 		indstNm: "은행",
			// 		insttCd: "BANK",
			// 		insttNm: "(주)우리은행",
			// 		prvBlncAmt: "100000.000"
			// 	}
			// ]

			setAcntblncData(data.slice(0, accMoreBtn));
			setAccDataLength(Math.ceil(data.length / moreSliceN));
		})
	}, [accMoreBtn])

	// 내 계좌 잔액 상태 같은지,적은지,많은지
	const balanceState = (data) => {
		let now = Number(data.blncAmt)
		let pre = Number(data.prvBlncAmt);
		if (now === pre) {
			setBalanceType({
				type: 'qual',
				pay: 0
			})
		} else if (now > pre) {
			setBalanceType({
				type: 'now',
				pay: now - pre
			})
		} else if (now < pre) {
			setBalanceType({
				type: 'pre',
				pay: pre - now
			})
		}
	}

	// 내 계좌 잔액 
	const balanceBox = () => {
		if (balanceType === undefined) { return false }
		if (balanceType.type === 'qual') {
			return (
				<>
					<div className="balance mt_40">
						<i className="icon icon_balance_same" />
						<ul className="balance-area">
							<li>
								<span className="date on">오늘</span>
								<i className="icon money-many" />
								<p className="price price-today">{Lib.addComma(Number(accBalanceData.blncAmt))} 원</p>
							</li>
							<li>
								<span className="date">어제</span>
								<i className="icon money-many" />
								<p className="price">{Lib.addComma(Number(accBalanceData.prvBlncAmt))} 원</p>
							</li>
						</ul>
					</div>
					<div className="guide-box mt_20">오늘은 어제 대비 계좌 잔액에 변동이 없어요.</div>
				</>
			)
		} else if (balanceType.type === 'now') {
			return (
				<div className="balance mt_40">
					<i className="icon icon_balance_arrow_right" />
					<ul className="balance-area">
						<li>
							<span className="date on">오늘</span>
							<i className="icon money-many" />
							<p className="price price-today">{Lib.addComma(Number(accBalanceData.blncAmt))} 원</p>
							<span className="plus">+ {Lib.addComma(Number(balanceType.pay))}원</span>
						</li>
						<li>
							<span className="date">어제</span>
							<i className="icon money-less" />
							<p className="price">{Lib.addComma(Number(accBalanceData.prvBlncAmt))} 원</p>
						</li>
					</ul>
				</div>
			)
		} else if (balanceType.type === 'pre') {
			return (
				<div className="balance mt_40">
					<i className="icon icon_balance_arrow_left" />
					<ul className="balance-area">
						<li>
							<span className="date">오늘</span>
							<i className="icon money-less" />
							<p className="price">{Lib.addComma(Number(accBalanceData.blncAmt))} 원</p>
							<span className="minus">- {Lib.addComma(Number(balanceType.pay))}원</span>
						</li>
						<li>
							<span className="date on">어제</span>
							<i className="icon money-many" />
							<p className="price price-today">{Lib.addComma(Number(accBalanceData.prvBlncAmt))} 원</p>

						</li>
					</ul>
				</div>
			)
		} else {
			return <div className="guide-box mt_20">오늘은 어제 대비 계좌 잔액에 변동이 없어요.</div>
		}
	}

	// 내 지출 금액
	const withdrExpState = (data) => {
		let amt = Number(data.blncAmt) - Number(data.prvBlncAmt);
		if (Number(data.blncAmt) > Number(data.prvBlncAmt)) {
			return (
				<span className={`${styles.info} plus`}>+{Lib.addComma(amt)} 원</span>
			)
		} else if (Number(data.blncAmt) < Number(data.prvBlncAmt)) {
			return (
				<span className={`${styles.info} minus`}>{Lib.addComma(amt)} 원</span>
			)
		} else {
			return ''
		}
	}

	// 더보기 버튼
	const accMoreButton = () => {
		setAccMoreBtn(accMoreBtn + moreSliceN)
	}

	// 더보기 버튼
	const payMorebutton = () => {
		setPayMoreBtn(payMoreBtn + moreSliceN)
	}



	const payMorebtnBox = () => {
		if (dataPayLength === 0) {
			return ''
		} else if (dataPayLength > 1 && (payMoreBtn / moreSliceN) < dataPayLength) {
			return (
				<div className="padding" onClick={payMorebutton}>
					<Button className="btn btn--big">+ 더보기</Button>
				</div>
			)
		}
	}

	const accMorebtnBox = () => {
		if (dataAccLength === 0) {
			return ''
		} else if (dataAccLength > 1 && (accMoreBtn / moreSliceN) < dataAccLength) {
			return (
				<div className="padding pb_50" onClick={accMoreButton}>
					<Button className="btn btn--big">+ 더보기</Button>
				</div>
			)
		}
	}

	// 캘린더 특정요일 구하기
	function getTodayLabel(day) {
		let label = {}
		// eslint-disable-next-line no-array-constructor
		var week = new Array('일', '월', '화', '수', '목', '금', '토');
		var todayN = new Date(day).getDay();
		var todayLabel = week[todayN];
		label = {
			todayLabel: todayLabel,
			todayN: todayN
		}
		return label
	}

	// 7일 데이터가 없을경우
	const weekpayEmptyBox = () => {
		let weekpayEmpty;
		if (withdrExpData) {
			weekpayEmpty = withdrExpData.lstWithdrExpNbr.find(el => Number(el.nbr) > 0)
			if (!weekpayEmpty) {
				return <div className="guide-box mt_20">7일 내에 예정된 지출이 없어요.</div>
			}
		}
	}

	// 일요일 토요일 표시
	const setCalendarDay = (d) => {
		if (d === 0) {
			return 'sunday'
		} else if (d === 6) {
			return 'saturday'
		} else { return '' }
	}

	// 달력 정보
	const calendarBox = () => {
		return (
			<>
				<div className="mt_20">
					<div className="calendar-area calendar-head">
						{withdrExpData && withdrExpData.lstWithdrExpNbr.map((item, index) => {
							return <div key={index} className={setCalendarDay(getTodayLabel(item.de).todayN)}>{getTodayLabel(item.de).todayLabel}</div>
						})}
					</div>
					<div className="calendar-area">
						{withdrExpData && withdrExpData.lstWithdrExpNbr.map((item, index) => {
							// let getdayState = getTodayLabel(item.de)
							let day = item.de.replace(/-/g, "");
							let count = Number(item.nbr);
							let countView = false;
							if (count > 0) countView = true;
							return <>
								<div className={index === 0 ? `active ${setCalendarDay(getTodayLabel(item.de).todayN)}` : setCalendarDay(getTodayLabel(item.de).todayN)} key={index}>{day.substr(6, 8)} {countView && (<span className="count">{count}건</span>)}</div>
							</>
						})}
					</div>
				</div>
				{weekpayEmptyBox()}

			</>
		)
	}

	return (
		<div className="page">
			<div className={`${styles["main-visual"]} ${styles.normal} shadow`}>
				<div>
					<div className={styles["tit-wrap"]}>
						<div className={styles.title}>
							<p className="mt_10">오늘은 또 무슨일이?</p>
							<h2>Daily 리포트</h2>
							<p className="flex-align_center mt_20" style={{ color: "#999" }}>{today} 기준</p>
						</div>
						<Link to="/mydata" className="btn-link btn--gradient mt_30">마이데이터로 가기<i className="icon icon_btn_arrow_white ml_5" style={{ marginTop: "-0.3rem" }} /></Link>
					</div>
					<div className={styles["report-obejct"]} />
				</div>
			</div>

			<div className="shadow">
				<div>
					<div className="padding">
						<div className="flex-align_center">
							<h3 className="mr_5">내 계좌 잔액</h3>
							<i className="icon icon_question" onClick={showConfirm} />
						</div>
						{accBalanceData && (
							<>
								{balanceBox()}
							</>
						)}
					</div>
					{acntblncData && acntblncData.length > 0 ? (
						<>
							<hr className="m_20" />
							<ul className={`${styles["bank-list"]} list-bg pt_10`}>
								{acntblncData.map((item, index) => {
									return (
										<li key={index}>
											<div className="flex-align_center">
												<div className="img-box img-symbol">
													<Logo code={item.insttCd} style={{ 'width': '4rem', 'height': '4rem' }} />
												</div>
												<span className="ml_10">{item.insttNm}</span>
											</div>
											<div>
												<p className={styles.price}>{Lib.addComma(Number(item.blncAmt))} 원</p>
												{withdrExpState(item)}
											</div>
										</li>
									)
								})}
							</ul>
							{accMorebtnBox()}
						</>
					) : ''}
				</div>
			</div>

			<div className="padding">
				<h3>내 지출 일정</h3>
				<div className="calendar-dot">Today</div>
				{calendarBox()}
			</div>

			{/* {withdrExpList && withdrExpList.length > 0 ? (
				<>
					<hr style={{ marginBottom: "3rem" }} />
					<div className="flex-align_center mb_30" style={{ padding: "0 2rem" }}>
						{listState && (
							<h3 className="mr_10">{Lib.dateFormat(listState.today, ".").substr(5, 9)}</h3>
						)}
						{listState && listState.ddayCound >= 0 ? (
							<i className="tag tag-red">D-{listState.ddayCound}</i>
						) : ''}
					</div>
					<ul className={`${styles["bank-list"]} list-bg`}>
						{withdrExpList.map((item, index) => {
							return (
								<li key={index}>
									<div className="img-box img-symbol">
										<img src={`/images/logo/${item.payInsttCd}.png`} alt="" />
									</div>
									<div className="flex--item_1 text-align_left ml_20">
										<strong>[{item.bankInsttNm}]</strong>
										<div className="flex-justify_between">
											<p className="mt_5"> {item.prodNm}</p>
										</div>
										<p className={`${styles.round} mt_10`}>{item.acntNo} / 4회차</p>
										<span className={`${styles["bank-guide"]} mt_5`}>자동이체 : {item.bankInsttNm} {item.acntNo}</span>
									</div>
								</li>
							)
						})}
					</ul>
					{payMorebtnBox()}
				</>
			) : ''} */}


			{withdrExpList && withdrExpList.length > 0 ? (
				<>
					<hr style={{ marginBottom: "3rem" }} />
					{/* <div className="flex-align_center mb_30" style={{ padding: "0 2rem" }}>
						{listState && (
							<h3 className="mr_10">{Lib.dateFormat(listState.today, ".").substr(5, 9)}</h3>
						)}
						{listState && listState.ddayCound >= 0 ? (
							<i className="tag tag-red">D-{listState.ddayCound}</i>
						) : ''}
					</div> */}
					{
						withdrExpData ?
							withdrExpData.lstWithdrExpNbr.map((item, index) => {
								return (
									withdrExpData.lstWithdrExpDtl[item.de].length > 0 &&
									<React.Fragment key={index}>
										<div className="flex-align_center mb_30" style={{ padding: "0 2rem" }}>
											<h3 className="mr_10">{Lib.dateFormat(item.de, ".").substr(5, 9)}</h3>
											{
												Lib.getDday(Lib.GetServerDate(), Lib.ChanageNewDate(item.de)) === 0 ?
													<i className="tag tag-red">D-day</i>
													:
													<i className="tag tag-red">D-{Lib.getDday(Lib.GetServerDate(), Lib.ChanageNewDate(item.de))}</i>
											}
										</div>

										< ul className={`${styles["bank-list"]} list-bg`}>
											{
												withdrExpData.lstWithdrExpDtl[item.de].map((item, index) => {
													return (
														<li key={index}>
															<div className="img-box img-symbol">
																<img src={`/images/logo/${item.payInsttCd}.png`} alt="" />
															</div>
															<div className="flex--item_1 text-align_left ml_20">
																{
																	item.itemCd === "CNSMP" ?
																		<>
																			<strong>카드대금결제</strong>
																			<div className="flex-justify_between">
																				<p className="mt_5" style={{ width: "14rem" }}>{item.payInsttNm}</p>
																				<p className={styles.price}>{Lib.addComma(Number(item.payAmt))} 원</p>
																			</div>
																			<span className={`${styles["bank-guide"]} mt_5`}>결제계좌 : {item.bankInsttNm}</span>
																		</>
																		: item.itemCd === "LOAN" ?
																			<>
																				<strong>대출이자상환</strong>
																				<div className="flex-justify_between">
																					<p className="mt_5">{item.prodNm}</p>
																				</div>
																				<p className={`${styles.round} mt_10`}>{item.acntNo} {item.rndCnt && item.rndCnt !== null ? `${item.rndCnt} / 회차` : ""}</p>
																				<span className={`${styles["bank-guide"]} mt_5`}>자동이체 : {item.bankInsttNm} ({item.acntNo})</span>
																			</>
																			:
																			item.itemCd === "TELECOM" ?
																			<>
																				<strong>통신비</strong>
																				<div className="flex-justify_between">
																					<p className="mt_5">{item.payInsttNm}</p>
																					<p className={styles.price}>{Lib.addComma(Number(item.payAmt))} 원</p>
																				</div>
																				<span className={`${styles["bank-guide"]} mt_5`}>결제일 : {item.payDe} </span>
																			</>
																			:
																			null
																}
															</div>
														</li>
													)
												})
											}
										</ul>
									</React.Fragment>
								)
							})
							:
							""
					}

					{/* <ul className={`${styles["bank-list"]} list-bg`}>
						{withdrExpList.map((item, index) => {
							return (
								<li key={index}>
									<div className="img-box img-symbol">
										<img src={`/images/logo/${item.payInsttCd}.png`} alt="" />
									</div>
									<div className="flex--item_1 text-align_left ml_20">
										{
											item.itemCd === "CNSMP" ?
												<>
													<strong>카드대금결제</strong>
													<div className="flex-justify_between">
														<p className="mt_5" style={{ width: "14rem" }}>{item.payInsttNm}</p>
														<p className={styles.price}>{Lib.addComma(Number(item.payAmt))} 원</p>
													</div>
													<span className={`${styles["bank-guide"]} mt_5`}>결제계좌 : {item.payInsttNm}</span>
												</>
												: item.itemCd === "LOAN" ?
													<>
														<strong>대출이자상환</strong>
														<div className="flex-justify_between">
															<p className="mt_5">{item.prodNm}</p>
														</div>
														<p className={`${styles.round} mt_10`}>{item.acntNo} / ?회차</p>
														<span className={`${styles["bank-guide"]} mt_5`}>자동이체 : {item.bankInsttNm} ({item.acntNo})</span>
													</>
													:
													null

										}
									</div>
								</li>
							)
						})}
					</ul> */}
					{payMorebtnBox()}
				</>
			) : ''
			}
			<ConfirmLayer show={showLayer} closeConfirm={closeConfirm}/>
		</div >
	)
}

const ConfirmLayer = ({ show, closeConfirm }) => {
	return (
		<LayerBottom title="내 계좌 잔액" show={show} closeLayer={closeConfirm}>
			<div className="layer-text py_10">
				내 계좌 잔액은 은행 입출금 및 예/적금 계좌 잔액의 합산 금액이에요. 어제 대비 오늘 잔액에 변화가 있는 내역만 요약하여 보여줘요.
				자세한 내용은 마이데이터 메뉴로 이동해 확인할 수 있어요.
			</div>
		</LayerBottom>
	)
}

export default Report
